import { Injectable } from '@angular/core';
import { HttpServiceService } from './http-service.service';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { CookieService } from '../Services/cookie';
@Injectable({
  providedIn: 'root'
})
export class CardServiceService {
  pendingStatus: string;
  pendingCPR: string;
  requestType:string;

  constructor(private http: HttpServiceService, private auth: AuthService, private cookieService:CookieService, private config: ConfigService, private common: CommonService) { }

  public GetTransactionUngroupURL = "Card/GetTransactionUngroup";
  public GetTransactiongroupURL = "Card/GetTransactiongroup";
  public UpdateCardStatusURL = "Card/UpdateCardStatus";
  public GetCardDatesURL = "Card/GetCardDates"
  public CardStatementURL = "Card/CardStatementv1"
  public CardDataURL = "Card/CardData"
  public CardDataV1URL = "Card/CardDataV1"
  public UpdateNickNameURL = "Card/UpdateNickName"
  //public GetPendingLimitRequestURL = "Card/GetPendingLimitRequests" 
  public GetPendingLimitRequestURL = "Card/GetPendingLimitRequestsV1" 
  public AutoTempLimitURL = "Card/AutoTempLimit"
  public AcceptCardLimitURL = "Card/AcceptCardLimit"
  public DeclineCardLimitURL = "Card/DeclineCardLimit"
  public GetChargesURL = "Card/GetCharges"
  public SaveNewLimitURL = "Card/SaveNewLimit"


  // Release R2
  public CardReplacementURL = "Card/CardReplacement"
  public GetLettersListURL = "Card/GetLettersList"
  public CheckLettersEligibilityURL = "Card/CheckLettersEligibility"
  public RequestingLettersURL = "Card/RequestingLetters"
  public RequestPhysicalCardURL = "Card/RequestPhysicalCard"
  public ReplaceDigitalCardURL = "Card/ReplaceDigitalCard"
  public CardActivationURL = "Card/CardActivation"


  public CardListForOnboardingURL = "Card/GetListForOnboarding"

  public AutoTempLimitObj = {
    error: "",
    status: "",
    limitRequestId: "",
    response: {
      status: "",
      requestID: "",
      userID: "",
      stage: "",
      eligibleAmt: "",
      requestedLimit: "",
      startDate: "",
      endDate: "",
    }
  }

  GetCharges(ChargesId, token) {
    console.log('GetChargesReq+Token', ChargesId,token );
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetChargesURL, {ChargesId:ChargesId}, token).subscribe((res: any) => {
        resolve(res)
        console.log('GetChargesResponse',res);
      }, (Error) => {
        resolve(Error);
        console.log('GetChargesError',Error );
      })
    })
  }

  FilterIcon(token) {
    console.log('FilterIconReq',token );
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.CardListForOnboardingURL, {}, token).subscribe((res: any) => {
        resolve(res)
        console.log('FilterIconResponse',res);
      }, (Error) => {
        resolve(Error);
        console.log('FilterIconError',Error );
      })
    })
  }

  SaveNewLimit(body, token) {
    console.log('SaveNewLimit', body);
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.SaveNewLimitURL, body, token).subscribe((res: any) => {
        resolve(res)
        console.log('SaveNewLimit',res);
      }, (Error) => {
        resolve(Error);
        console.log('SaveNewLimit',Error );
      })
    })
  }

  GetTransactionUngroup(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetTransactionUngroupURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
          console.log("GetTransactionUngroup",res);
        }
        resolve(res)

      }, (Error) => {
        console.log("GetTransactionUngroupErro",Error);

        resolve(Error);
      })

    })

  }
  GetTransactiongroup(data, token) {
  console.log("GetTransactiongroupReq", data)
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetTransactiongroupURL, data, token).subscribe((res: any) => {
        console.log("GetTransactiongroupRes", res)
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  UpdateCardStatus(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.UpdateCardStatusURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
         console.log("UpdateCardStatusRes",res);
        }
        resolve(res)
        console.log("UpdateCardStatusRes",res);

      }, (Error) => {
        resolve(Error);
        console.log("UpdateCardStatusRes",Error);

      })

    })

  }
  UpdateNickName(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.UpdateNickNameURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  GetCardDates(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetCardDatesURL, data, token).subscribe((res: any) => {
      console.log("GetCardDates",res)
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  CardStatement(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.CardStatementURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  CardData(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.CardDataURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  CardDataV1(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.CardDataV1URL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)
        console.log("CardDataV1",res);
      }, (Error) => {
        resolve(Error);
        console.log("CardDataV1Error",Error);
      })

    })

  }
  CardReplacement(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.CardReplacementURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)
        console.log('CardReplacement', res);

      }, (Error) => {
        resolve(Error);
        console.log('CardReplacementError', Error);

      })

    })

  }
  GetLettersList(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetLettersListURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)
        console.log('GetLettersList', res);

      }, (Error) => {
        resolve(Error);
        console.log('GetLettersListError', Error);

      })

    })

  }
  CheckLettersEligibility(data, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.CheckLettersEligibilityURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)
        console.log('CheckLettersEligibility', res);

      }, (Error) => {
        resolve(Error);
        console.log('CheckLettersEligibilityError', Error);

      })

    })

  }
  RequestingLetters(data, token) {
    console.log("RequestingLettersObject", data);
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.RequestingLettersURL, data, token).subscribe((res: any) => {
        if (res.response.code) {
          if (res.response.code == 1) {

          }
        }
        resolve(res)
        console.log('RequestingLetters', res);

      }, (Error) => {
        resolve(Error);
        console.log('RequestingLettersError', Error);

      })

    })

  }


  GetPendingLimitRequest(token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetPendingLimitRequestURL, {}, token).subscribe((res: any) => {
        console.log('GetPendingLimitRequestResponse', res)
        this.pendingCPR = res?.response?.content?.limitRequests.length > 0 ? res.response.content.limitRequests[0].cpr : ''

        this.pendingStatus = res?.response?.content?.limitRequests.length > 0 ? res.response.content.limitRequests[0].status : ''

        this.requestType = res?.response?.content?.limitRequests.length > 0 ? res.response.content.limitRequests[0].requestType:""
        console.log('this.pendingStatus ',this.pendingStatus )
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }

  AutoTempLimit(CardId, token) {

    console.log('AutoTempLimitReq', CardId,token)
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.AutoTempLimitURL, { CardId: CardId }, token).subscribe((res: any) => {

        console.log('AutoTempLimitResponse', res)
        if (res?.response?.code == 1) {

          this.AutoTempLimitObj = res.response.content;
          // let key = this.cookieService.generateKey();
          this.cookieService.set("referenceId", res.response.content,true);
          this.cookieService.set('AutoTempLimitObj',JSON.stringify(res.response.content),true);
        }
        resolve(res)

      }, (Error) => {
        resolve(Error);
        console.log('AutoTempLimitError', Error)

      })

    })
  }

  AcceptCardLimit(LimitRequestId, token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.AcceptCardLimitURL, { LimitRequestId: LimitRequestId }, token).subscribe((res: any) => {
        console.log('AcceptCardLimitResponse', res)

        resolve(res)

      }, (Error) => {
        resolve(Error);
        console.log('AcceptCardLimitError', Error)

      })

    })
  }

  DeclineCardLimit(LimitRequestId, DeclineReasonCode, DeclineReasonDesc, Remarks, token) {

    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.DeclineCardLimitURL, { LimitRequestId: LimitRequestId, DeclineReasonCode: DeclineReasonCode, DeclineReasonDesc: DeclineReasonDesc, Remarks: Remarks }, token).subscribe((res: any) => {

       console.log('DeclineCardLimitResponse', res)

        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })
  }



}
